// sourceDispatchCard.tsx
import React from "react";
import "./sourceDispatchCard.scss";

export interface SourceDispatchCardProps {
  label?: "Source Dispatch" | "Move Dispatch";
  turnNumber: string;
  carrierName?: string;
  date?: string;
  departureTime?: string;
}

const SourceDispatchCard: React.FC<SourceDispatchCardProps> = ({
  label = "Source Dispatch",
  turnNumber,
  carrierName,
  date,
  departureTime,
}) => (
  <div className="source-dispatch-card">
    <span className="source-dispatch-card__label">{label}</span>
    <div className="source-dispatch-card__lane">{turnNumber}</div>
    <div className="source-dispatch-card__meta">
      {carrierName && (
        <span className="source-dispatch-card__carrier">{carrierName}</span>
      )}
      {date && <span className="source-dispatch-card__date">{date}</span>}
      {departureTime && (
        <span className="source-dispatch-card__departure">
          Dep {departureTime}
        </span>
      )}
    </div>
  </div>
);

export default SourceDispatchCard;